import { Component, Inject, Input, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
  selector: 'cigna-mat-alert-dialog',
  templateUrl: './mat-alert-dialog.component.html',
  styleUrls: ['./mat-alert-dialog.component.scss'],
})
export class MatAlertDialogComponent implements OnInit {
  constructor(
    private router: Router,
    private dialogRef: MatDialogRef<MatAlertDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: { heading: string; message: string; buttonText: string },
  ) {}
  urlPath = window.location.origin;
  ngOnInit(): void {}
  close() {
    if (this.data.message === 'global.noActiveClient') {
      this.dialogRef.close();
      this.router.navigate(['/public/app/signin']);
    } else {
      this.dialogRef.close();
    }
  }

  webitUrl() {
    if (this.urlPath.includes('int2.cignaforbrokers')) {
      return 'https://d-webittools.sys.cigna.com/employer/support/';
    } else if (
      this.urlPath.includes('pvs.cignaforbrokers') ||
      this.urlPath.includes('rlse.cignaforbrokers')
    ) {
      return '';
    }
    return 'https://webittools.sys.cigna.com/employer/support/';
  }
}
